/// <reference path="../services/datacontext.js" />
// app/tirocinante/aziende.js

(function () {
	'use strict';
    var controllerId = 'cndDomandaAdesione';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', cndDomandaAdesione]);

    function cndDomandaAdesione($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, 'logError');
		var logSuccess = getLogFn(controllerId, 'logSuccess');


		var vm = this;
		vm.title = 'domandaAdesione';
        vm.view = 'detail';       //Opzione list or detail
		vm.setView = setView;
		vm.sectionMenu = sectionMenu.setSection(vm.title);

		vm.objName = "domandaAdesione"; //Utilizzato per pannello authorization		
		vm.authorization = {};
		vm.showObjPanel = false;
		vm.record = {};
		vm.records = [];
		vm.countRecords = 0;
		vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.maxStep = 3;
        vm.errorAccess = '';
        vm.tSourceCode_ADES = 'ADES';
        vm.isVisibleLinkDomanda = false;

        vm.art11comma6 = 'L\'indennit\xE0 di partecipazione di cui al punto 1 non viene corrisposta a quei destinatari titolari di altre indennit\xE0 come quella di:<br />a. disoccupazione (NASpl);<br />b. prestazioni pensionistiche di vecchiaia o di anzianit\xE0, ovvero per l\'assegno sociale;<br />c. CIGS;<br />d. lavoratori cosiddetti disoccupati parziali (cio\xE8 quelli che pur avendo un lavoro dipendente o autonomo hanno un reddito annuo pari o inferiore a quello esente da IRPEF e come tali non sono obbligati a fare la dichiarazione dei redditi).';

        //Pannelli dei dati (viewAdes)
        vm.showPanelAdes1 = true;
        vm.showPanelAdes2 = true;
        vm.showPanelAdes3 = true;
        vm.showPanelAdes4 = false; //Dipende dalla scelta della misura
        vm.setShowPanelAdes1 = setShowPanelAdes1;
        vm.setShowPanelAdes2 = setShowPanelAdes2;
        vm.setShowPanelAdes3 = setShowPanelAdes3;
        vm.setShowPanelAdes4 = setShowPanelAdes4;

        //Pannelli dei dati (viewAtt)
        vm.showPanelAtt1 = true;
        vm.showPanelAtt2 = true;
        vm.showPanelAtt3 = true;
        vm.setShowPanelAtt1 = setShowPanelAtt1;
        vm.setShowPanelAtt2 = setShowPanelAtt2;
        vm.setShowPanelAtt3 = setShowPanelAtt3;

        //Pannelli dei dati (viewRiep)
        vm.showPanelRiep1 = true;
        vm.setShowPanelRiep1 = setShowPanelRiep1;
        

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.cndProgetto = {};
        vm.urlRoot = datacontext.adesione_getURL();


		//Elenco per Ordinamento
		vm.list = {};
		vm.list.ordine = ['Nominativo', 'Codice Fiscale'];
		vm.ordine = vm.list.ordine[0];
		vm.selectOrdine = function (item) {
			vm.ordine = item;
		};

		//Elenchi dettaglio
		vm.list.attach = [];
		
		vm.list.b_attach = false;
		

		//vm.getRecord = getRecord;
		//vm.getListAttach = getListAttach;

		//Conteggio Elenchi
		vm.countAttachProfilo = function () {
			var filter = {};
			return filterFilter(vm.list.attach, filter).length;
		}

        //vm.saveAll = saveAll;

        //Attach 2
        vm.tAttach_Needed = [];
        vm.list.attach_ades = [];
        vm.addAttach = addAttach;
        vm.getListAttach = getListAttach;
        vm.deleteAttach = deleteAttach;
        vm.extractP7MFile = getExtractP7MFile;
        vm.extractP7MInfo = getExtractP7MInfo;
        vm.populateAttach = populateAttach;

        

        //CND CV
        //vm.currVitae = {};
        //vm.resetTitoloFields = resetTitoloFields;
        //CNDCV_Spec
        //vm.cv_spec = {};
        //vm.list.cv_specs = [];
        //vm.addSpec = addSpec;
        //vm.deleteSpec = deleteSpec;
        //CNDCV_Servizio
        //vm.cv_servizio = {};
        //vm.list.cv_servizi = [];
        //vm.addServizio = addServizio;
        //vm.deleteServizio = deleteServizio;


		//Filtro
		vm.fNominativo = '';
		vm.fNascComuneId = -1;

		vm.fAttach = {};
		vm.setfAttach = setfAttach;

		//Elenchi per filtri e finestra modale di Create
        vm.cmblist = {};
        vm.cmblist.nasc_paesi = [];
        vm.cmblist.nasc_province = [];
        vm.cmblist.nasc_comuni = [];
        
        vm.cmblist.res_paesi = [];
        vm.cmblist.res_province = [];
        vm.cmblist.res_comuni = [];
        
        vm.cmblist.dom_paesi = [];
        vm.cmblist.dom_province = [];
        vm.cmblist.dom_comuni = [];

        vm.cmblist.staticivili = [];
        vm.cmblist.profili = [];
        vm.cmblist.titoliStudio = [];
        vm.cmblist.mesi = [
            { Id: 1, Name: 'Gennaio' },
            { Id: 2, Name: 'Febbraio' },
            { Id: 3, Name: 'Marzo' },
            { Id: 4, Name: 'Aprile' },
            { Id: 5, Name: 'Maggio' },
            { Id: 6, Name: 'Giugno' },
            { Id: 7, Name: 'Luglio' },
            { Id: 8, Name: 'Agosto' },
            { Id: 9, Name: 'Settembre' },
            { Id: 10, Name: 'Ottobre' },
            { Id: 11, Name: 'Novembre' },
            { Id: 12, Name: 'Dicembre' }
        ];

        vm.cmblist.dich1_02_cittadinanze = [];
        vm.cmblist.dich1_03_province = [];
        vm.cmblist.dich1_03_comuni = [];
        vm.cmblist.statiOccup = [];

        vm.tSource = {};
        vm.tAttach = [];
        vm.tAttach_Needed = [];


		//Metodi su interfaccia
		vm.activated = false;
		//vm.addAttach = addAttach;
        //vm.deleteAttach = deleteAttach;

        //DA
        vm.setCompleted = setCompleted;
        vm.setSent = setSent;
        vm.setAttachChecked = setAttachChecked;
        //CV
        //vm.setCompleted_CV = setCompleted_CV;
        //vm.setSent_CV = setSent_CV;
        //vm.unlock_CV = unlockCVItem;

        //Gestione conferma input di tipo Email
        vm.confirm = {};

        vm.setStep = setStep;
        vm.printAll = printAll;

        vm.containsGrado = containsGrado;
        vm.changedProfilo = false;
        vm.setChanged = setChanged;

		//vm.get = getRecord;
        vm.add = addModal;
        vm.saveAdes = saveOrUpdateItem;
		vm.delete = deleteItem;

        vm.resetComuni_Nasc = resetComuni_Nasc;
        vm.resetComuni_Res = resetComuni_Res;
        vm.resetComuni_Dom = resetComuni_Dom;
        //vm.resetComuni_Dich1_03 = resetComuni_Dich1_03;

        vm.reset_PaeseNasc = reset_PaeseNasc;
        vm.reset_PaeseRes = reset_PaeseRes;
        vm.reset_PaeseDom = reset_PaeseDom;
        vm.reset_DomUgualeRes = reset_DomUgualeRes;

        //vm.reset_Dich1_02 = reset_Dich1_02;
        //vm.reset_Dich1_05_condanne = reset_Dich1_05_condanne;
        //vm.reset_Dich1_08 = reset_Dich1_08;
        vm.reset_Dich2_09 = reset_Dich2_09;

        vm.ableDich2_02 = false;
        vm.changeDich2_02 = changeDich2_02;

        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;

        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;

	    
		//datapicker
		vm.open = function ($event, iOpened) {
			$event.preventDefault();
			$event.stopPropagation();

			vm.opened1 = false;
			if (iOpened == 1)
				vm.opened1 = true;
		};

		vm.clear = function ($event, iOpened) {
			if (iOpened == 1) {
				vm.record.NascData = '';
				vm.changed = true;
			}
		};

		vm.dateOptions = {
			formatYear: 'yy',
			startingDay: 1
		};

		vm.format = 'dd/MM/yyyy';

		// ---- ACTIVATE -------
        loadStepParams();
		activate();

        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {
                    if ($routeParams.domandaAdesioneUID != null) {
                        return getRecordByUID($routeParams.domandaAdesioneUID).then(function () {
                            console.info('vm.record', vm.record);
                            if (!vm.record.Completed) {
                                var promises = [getTSource(vm.tSourceCode_ADES), /*getTAttachNeeded(vm.tSourceCode_ADES), getTAttach(vm.tSourceCode_ADES), getTitoliStudio(), getStatiCivili(), getStatoOccup(),*/ getPaesi_Nasc(), getProvince_Nasc(), getPaesi_Res(), getProvince_Res(), getPaesi_Dom(), getProvince_Dom()/*, getCittadinanze_Dich1_02(), getProvince_Dich1_03()*/];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                            else if (!vm.record.AttachChecked) {
                                var promises = [getTSource(vm.tSourceCode_ADES), /*getTAttachNeeded(vm.tSourceCode_ADES), getTAttach(vm.tSourceCode_ADES)*/];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                        });
                    }
                    else {
                        vm.record.Id = 0;
                        vm.record.NascPaeseId = 0;
                        vm.record.ResPaeseId = 0;
                        vm.record.DomUgualeRes = 0;
                        vm.record.Dich2_02 = 0;
                        vm.confirm.Email = '';


                        var promises = [getTSource(vm.tSourceCode_ADES), /*getTAttachNeeded(vm.tSourceCode_ADES), getTAttach(vm.tSourceCode_ADES),  getTitoliStudio(), getStatiCivili(), getStatoOccup(),*/ getPaesi_Nasc(), getProvince_Nasc(), getPaesi_Res(), getProvince_Res(), getPaesi_Dom(), getProvince_Dom()/*, getCittadinanze_Dich1_02(), getProvince_Dich1_03()*/];
                        return common.activateController(promises, controllerId)
                            .then(function () {
                                return setStep(0);
                            });
                    }

                    vm.sectionMenu = sectionMenu.setSection(vm.title);
                    vm.activated = true;
                });
                sectionMenu.setProjectUId($routeParams.projectUID);
            }
		}


		//****************************************************
		// METODI 
		//****************************************************
        function setView(view) {
			return vm.view = view;
		}

        function nextStep() {
            bDialog.confirmationDialog('Attenzione', 'Si sta passando alla Fase successiva, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    setStep(vm.actualStep + 1);
                },
                function () { //NO
                    //
                }
            );
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "A";
            vm.titlesStep[0] = "Fase A";
            vm.subtitlesStep[0] = "Domanda di partecipazione";
            vm.descriptionsStep[0] = "In questa prima fase &egrave; richiesto l'inserimento dei dati necessari alla compilazione della 'Domanda di partecipazione'.<br/>&Egrave; possibile procedere alla fase successiva solo dopo aver inserito e salvato tutte le informazioni richieste in questa fase.";

            vm.labelsStep[1] = "B";
            vm.titlesStep[1] = "Fase B";
            vm.subtitlesStep[1] = "Upload Documentale";
            vm.descriptionsStep[1] = "In questa fase &egrave; richiesta la convalida dei dati; effettuata la convalida occore scaricare l'allegato 5 generato dal portale, firmarlo e ricaricarlo unitamente all'altra documentazione richiesta, compilando integralmente l'elenco.";

            vm.labelsStep[2] = "C";
            vm.titlesStep[2] = "Fase C";
            vm.subtitlesStep[2] = "Stampa ricevuta";
            vm.descriptionsStep[2] = "In questa fase &egrave possibile stampare la 'Ricevuta di partecipazione' contenente il codice univoco di identificazione della pratica.";
        }

        function setStepDefault() {
            if (vm.record.AttachChecked) {
                setStep(2);
            } else if (vm.record.Completed) {
                setStep(1);
            } else {
                setStep(0);
            }
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            switch (vm.actualStep) {
                case 0:
                    setView('viewAdes');
                    break;
                case 1:
                    populateAttach();
                    setView('viewAtt');
                    break;
                case 2:
                    setView('viewRiep');
                    break;
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            var spanEdit = 'span-select';
            var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = (vm.record != undefined && vm.record.Completed);
            vm.stepCompleted[1] = (vm.record != undefined && vm.record.AttachChecked);
            vm.stepCompleted[2] = (vm.record != undefined && vm.record.Sent);

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAdes':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < (vm.maxStep - 1) && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.loading, form);
            //disable = form.$pristine || form.$invalid || vm.loading;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.loading || vm.record.Completed
                        || (vm.record.Email != undefined && vm.record.Email.toLowerCase() != vm.confirm.Email.toLowerCase());
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.loading, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }

        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }


        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }
        //Gestione per viewAdes
        function setShowPanelAdes1() {
            return vm.showPanelAdes1 = !vm.showPanelAdes1;
        }
        function setShowPanelAdes2() {
            return vm.showPanelAdes2 = !vm.showPanelAdes2;
        }
        function setShowPanelAdes3() {
            return vm.showPanelAdes3 = !vm.showPanelAdes3;
        }
        function setShowPanelAdes4() {
            return vm.showPanelAdes4 = !vm.showPanelAdes4;
        }
        //Gestione per viewAtt
        function setShowPanelAtt1() {
            return vm.showPanelAtt1 = !vm.showPanelAtt1;
        }
        function setShowPanelAtt2() {
            return vm.showPanelAtt2 = !vm.showPanelAtt2;
        }
        function setShowPanelAtt3() {
            return vm.showPanelAtt3 = !vm.showPanelAtt3;
        }
        //Gestione per viewRiep
        function setShowPanelRiep1() {
            return vm.showPanelRiep1 = !vm.showPanelRiep1;
        }
		

        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;

                        var dt = new Date();
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }
                        
                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                        getProfili(vm.cndProgetto.Id);
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    }
                );
        }

        //*************************************
        // Domanda di Adesione

        function setCompleted() {
            if (!vm.record.Sent && !vm.record.Completed)
                bDialog.confirmationDialog('Attenzione', 'Convalidando i dati non sar\xE0 possibile apportare alcuna modifica ai dati inseriti nella \'Fase A\'. Vuoi convalidare?', 'Convalida').then(
                    function () { //YES
                        vm.record.Completed = true;
                        vm.loading = true;
                        return saveOrUpdateItem().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Completed = false;
                                return true;
                            }
                            setClassSeqWiz();
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
        }

        function setSent() {
            if (!vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti.', 'Procedi').then(
                    function () { //YES
                        vm.record.Sent = true;
                        vm.loading = true;
                        return saveOrUpdateItem().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Sent = false;
                                return true;
                            }
                            setClassSeqWiz();
                            printRicevuta();
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                printRicevuta();
            }
        }

        function setAttachChecked() {
            if (!vm.record.AttachChecked) {
                bDialog.confirmationDialog('Attenzione', 'Si sta proseguendo alla "Fase C", pertanto, non sar\xE0 possibile tornare indietro e/o aggiungere, modificare, eliminare gli allegati caricati a sistema. Procedere? ', 'Procedi').then(
                    function () { //YES
                        vm.record.AttachChecked = true;
                        vm.loading = true;
                        return saveOrUpdateItem().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.AttachChecked = false;
                                setStep(1);
                                return false;
                            }
                            setClassSeqWiz();
                            setStep(2);
                            //setView('viewRiep');
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(1);
                        return true;
                    }
                );
            }

        }


        //***************************
        // Get URL Allegato ACCREDITAMENTO

        function getPDF_All(index) {
            vm.loading = false;
            return datacontext.cndDomandaAdesione_findPDFAll($routeParams.domandaAdesioneUID, $routeParams.projectUID, index)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        switch (index) {
                            case 2:
                                return vm.linkPDFAll2 = data.url;
                                break;
                            case 3:
                                return vm.linkPDFAll3 = data.url;
                                break;
                        }
                    }
                });
        }

        //*******************************
        // Print PDF ACCREDITAMENTOs

        function printAll(index) {
            vm.loading = true;
            return datacontext.cndDomandaAdesione_printPDFAll($routeParams.projectUID, $routeParams.domandaAdesioneUID, index)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        //recupero allegato appena creato
                        var a = document.createElement("a");
                        a.setAttribute('style', 'display:none');
                        document.body.appendChild(a);

                        a.href = data.url;
                        if ($rootScope.detectIE()) {
                            a.target = 'hiddenIframe';
                        }
                        else
                            a.download = 'Allegato' + index + '_' + $routeParams.domandaAdesioneUID + '.pdf';
                        a.click();
                        document.body.removeChild(a);

                        switch (index) {
                            case 5:
                                return vm.linkPDFAll5 = data.url;
                                break;
                        }
                    } else
                        return true;
                });
        }

        //*******************************
        // Print PDF RICEVUTA
        function printRicevuta() {
            if (vm.record.Sent) {
                vm.loading = true;
                return datacontext.cndDomandaAdesione_printRicevuta($routeParams.projectUID, $routeParams.domandaAdesioneUID)
                    .then(function (data) {
                        vm.loading = false;
                        if (data && data.url) {
                            //recupero allegato appena creato
                            var a = document.createElement("a");
                            a.setAttribute('style', 'display:none');
                            document.body.appendChild(a);

                            a.href = data.url;
                            if ($rootScope.detectIE()) {
                                a.target = 'hiddenIframe';
                            }
                            else
                                a.download = 'Ricevuta_' + $routeParams.domandaAdesioneUID + '.pdf';
                            a.click();
                            document.body.removeChild(a);

                            getRecordByUID($routeParams.domandaAdesioneUID);
                            return vm.linkPDFRicevuta = data.url;
                        } else
                            return true;
                    });
            }
        }

        //=====================================


        function setRecord(data) {
            vm.record = data;
            if (vm.record.Deleted || vm.record.Annulled) {
                vm.errorAccess = 'linkError';
                return;
            }
            vm.showPanelAdes4 = true;
            if (vm.record.Completed)
                return;

            //Abilita questo codice solo per sistemazioni grafiche della comunicazione Link di Accesso
            vm.isVisibleLinkDomanda = true;
            

            //Reset campi Notifiche
            vm.validFieldsCF = true;
            vm.validPIVA = true;
            vm.validCF = true;

            if (vm.record.NascData != null) vm.record.NascData = new Date(vm.record.NascData);
            if (vm.record.Email != null) vm.confirm.Email = vm.record.Email;

            ////Azzera liste
            //vm.list.attach = [];
            //vm.list.b_attach = false;
            //vm.existsCF = false;

            //Aggiorno campi
            getComuni_Nasc(vm.record.NascProvinciaId);
            getComuni_Res(vm.record.ResProvinciaId);
            getComuni_Dom(vm.record.DomProvinciaId);
            getComuni_Dich1_03(vm.record.Dich1_03_ProvinciaId);

            changeDich2_02();
        }

        function showAlertDivs(errorAccess) {
            var msg = '';

            vm.errorAccess = errorAccess;

            if (errorAccess == 'linkError') {
                msg = 'Attenzione! Il link utilizzato e\' errato.';
            }

            if (msg != '') return logError(msg);

            return false;
        }

        function getRecordByUID(uid) {
            if (vm.cmblist.nasc_province.length == 0) getProvince_Nasc();
            if (vm.cmblist.res_province.length == 0) getProvince_Res();
            if (vm.cmblist.dom_province.length == 0) getProvince_Dom();

            return datacontext.cndDomandaAdesione_getByUID(uid, $routeParams.projectUID).then(function (data) {
                if (data == null || $.isNumeric(data) || data.Id == 0) {
                    showAlertDivs('linkError');
                    return false;
                }
                //Riduco il pannello con le modalit� di utilizzo dello strumento
                vm.showInfoMsg = false;

                setRecord(data); //vm.record = data; 
                setStepDefault();
                vm.record.ProgettoUId = $routeParams.projectUID;                
            });
        }


		function addRecord(id) {
			return datacontext.cndDomandaAdesione_get(id).then(function (data) {
				vm.records.push(data);
				vm.countRecords++;
			});
        }

        function containsGrado(index, profiloId) {
            index = parseInt(Math.pow(2, index));
            if ((index & profiloId) == index)
                return true;
            return false;
        }

        function setChanged() {
            if(!vm.changedProfilo)
                vm.changedProfilo = true;

            if (vm.changedProfilo)
                vm.showPanelAdes4 = true;

            if (!vm.record.ProfiloId) {
                vm.record.Dich2_01 = false;
                vm.showPanelAdes4 = false;
            }

            vm.record.strDich2_04_ISEE = '';
            vm.record.Dich2_02 = 0;            

            changeDich2_02();
            
            return vm.changedProfilo;
        }

        function setProfiloId() {
            if (vm.cndProgetto.iTProfilo == 2) {
                var sum = 0;
                $("input:checkbox[name=listId]:checked").each(function () {
                    var id = $(this).val();
                    var exp = id;
                    sum += parseInt(Math.pow(2, exp));
                });
                return vm.record.ProfiloId = sum;
            }
        }

        function changeDich2_02() {
            if (vm.record.Dich2_02 != 0 || (vm.record.ProfiloId == 3 || vm.record.ProfiloId == 12))
                vm.ableDich2_02 = true;
            else
                vm.ableDich2_02 = false;
        }

        function saveOrUpdateItem() {
            unResetItem(vm.record);
            setProfiloId();
            vm.changedProfilo = false;

            if (vm.record == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Dopo il primo salvataggio non sar\xE0 pi\xF9 possibile modificare il campo "CODICE FISCALE". Procedere?', 'OK').then(
                    function () { //YES
                        //Parametro di appoggio per send_Email
                        vm.record.ProgettoUId = $routeParams.projectUID;
                        vm.loading = true;
                        return datacontext.cndDomandaAdesione_add(vm.record).then(function (data) {
                            vm.loading = false;
                            if (data == "409") {
                                logError('Errore: codice fiscale esistente. ');
                                return data;
                            }
                            if (data == "304") {
                                logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                                return data;
                            }
                            if (data == "417") {
                                logError('Errore: importo ISEE oltre il valore consentito ');
                                return data;
                            }
                            if (data == "501") {
                                logError('Errore: codice fiscale non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if ($.isNumeric(data)) {
                                logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                                return data;
                            }

                            if (data) {
                                setRecord(data); //vm.record = data;

                                $routeParams.domandaAdesioneUID = vm.record.UID;
                                //getListAttach(vm.record.Id);

                                if (vm.record.Id > 0) {
                                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                                    vm.showInfoMsg = false;
                                }

                                return logSuccess('E\' stata inviata una email all\'indirizzo ' + vm.record.Email + ' con i dati inseriti. ');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                vm.loading = true;
                return datacontext.cndDomandaAdesione_update(vm.record).then(function (data) {
                    vm.loading = false;
                    if (data == "409") {
                        logError('Errore: codice fiscale esistente. ');
                        return data;
                    }
                    if (data == "403") {
                        logError("Attenzione dati mancanti. ");
                        return data;
                    }
                    if (data == "304") {
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "406") {
                        logError("Attenzione mancano alcuni allegati, inserirli prima di effettuare la trasmissione. ");
                        return data;
                    }
                    if (data == "417") {
                        logError('Errore: importo ISEE oltre il valore consentito ');
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                        return data;
                    }

                    if (data) {
                        setRecord(data); //vm.record = data;
                        $routeParams.domandaAdesioneUID = vm.record.UID;
                        logSuccess('Dati salvati');
                        return true;
                    }
                });
            }
        }

        //Sistemo i campi che ho resettato prima di mandarli al controller
        function unResetItem(item) {
            if (item.DomUgualeRes == 0) {
                item.DomPaeseId = 0;
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
                item.DomIndirizzo = '';
                item.DomCap = '';
            }

            if (item.NascPaeseId > 0) {
                item.NascProvinciaId = 0;
                item.NascComuneId = 0;
            }

            if (item.ResPaeseId > 0) {
                item.ResProvinciaId = 0;
                item.ResComuneId = 0;
            }

            if (item.DomPaeseId > 0) {
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
            }

            if (!item.Dich1_02) {
                item.Dich1_02_CittadinanzaId = 0;
            }
        }

		function deleteItem(item) {
			var msg = ' la domanda di adesione di : ' + item.CodiceFiscale;
			bDialog.deleteDialog(msg).then(function () {
				return datacontext.cndDomandaAdesione_delete(item.Id).then(function (data) {
					if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

					var index = vm.records.indexOf(item)
					vm.records.splice(index, 1);
					vm.countRecords--;
				});
			});
        }


        //**********************************************************************
        //GESTIONE ATTACH 2

        function populateAttach() {
            vm.ades_ref = '';
            if (vm.record != undefined && vm.record.Id != 0 && vm.record.Id != undefined) {
                vm.ades_ref = vm.record.Cognome + ' ' + vm.record.Nome + ' (' + vm.record.CodiceFiscale + ')';
                return getListAttach().then(function () {
                    return true;
                });
            }
        }

        function getListAttach() {
            vm.list.attach_ades = [];
            return datacontext.attach_getAllCND(0, 0, $routeParams.projectUID, $routeParams.domandaAdesioneUID, vm.tSourceCode_ADES, 0, vm.record.Id, vm.fAttach.TAttachId, '').then(function (data_ATT) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data_ATT)) vm.list.attach_ades = data_ATT;

                return datacontext.tAttach_getAll(0, 0, vm.tSourceCode_ADES, 0, '', 0, '').then(function (data_TA) {
                    vm.tAttach_Needed = data_TA;

                    return datacontext.tAttachVisibility_getAll(0, 0, vm.tSourceCode_ADES).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        vm.tAttach_Needed.forEach(function (item_TA) {
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.Name;

                            if (typeof (vm.list.attach_ades) == 'undefined') vm.list.attach_ades = [];
                            var myrec = _.find(vm.list.attach_ades, { 'TAttachId': item_TA.Id });
                            var myTAV = _.find(tAttVis, { 'TAttachId': item_TA.Id });

                            if (typeof (myTAV) == 'undefined') {
                                myTAV = {};
                                myTAV.bRead = true;
                                myTAV.bInsert = true;
                                myTAV.bUpdate = true;
                                myTAV.bDelete = true;
                                myTAV.iTags = 0;
                            }

                            att.bRead = myTAV.bRead;
                            att.bInsert = myTAV.bInsert;
                            att.bUpdate = myTAV.bUpdate;
                            att.bDelete = myTAV.bDelete;
                            att.iTags = myTAV.iTags;

                            if (typeof (myrec) == 'undefined') {
                                if (att.bRead)
                                    vm.list.attach_ades.push(att);
                            }
                            else {
                                myrec.bRead = myTAV.bRead;
                                myrec.bInsert = myTAV.bInsert;
                                myrec.bUpdate = myTAV.bUpdate;
                                myrec.bDelete = myTAV.bDelete;
                                myrec.iTags = myTAV.iTags;

                                var items = _.groupBy(vm.list.attach_ades, { 'TAttachId': item_TA.Id });

                                items.true.forEach(function (i) {
                                    i.bRead = myTAV.bRead;
                                    i.bInsert = myTAV.bInsert;
                                    i.bUpdate = myTAV.bUpdate;
                                    i.bDelete = myTAV.bDelete;
                                    i.iTags = myTAV.iTags;
                                });

                                if (myrec.bInsert) {                                    
                                    if (item_TA.MaxValue == 99 || item_TA.MaxValue > items.true.length) 
                                        vm.list.attach_ades.push(att);                                        
                                }
                            }
                        });
                    });
                });

                return vm.list.attach_ades;
            });
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {
                return vm.tAttach_Needed = data;
            });
        }

        function getExtractP7MFile(id) {
            return datacontext.attach_extract(id).then(function (data) {
                if (data == "ERR01") return logError("Errore: il documento non \xE8 un documento 'P7M' valido. ");
                if (data == "ERR02") return logError("Errore: documento non trovato. ");
                if (data == "ERR03") return logError("Errore: il documento non ha firma digitale. ");

                var url = data;
                window.open(url, 'Download');
            });
        }

        function getExtractP7MInfo(id) {
            var fileName = "";
            return datacontext.attach_extractDigitalSignInfo(id).then(function (data) {
                fileName = data;

                if (data) {
                    common.$http.get('/api/pdf/GetVerifySign?id=' + id, { responseType: 'arraybuffer' })
                        .then(function (response) {
                            if (response.status == 204) {

                                logError('Il documento non ha Firma Digitale');
                                return;
                            }

                            var a = document.createElement("a");
                            a.setAttribute('style', 'display:none');
                            document.body.appendChild(a);
                            var file = new Blob([response.data], { type: 'application/pdf' });
                            var fileURL = URL.createObjectURL(file);
                            a.href = fileURL;
                            fileName = fileName.substring(0, fileName.indexOf('.'));

                            if ($rootScope.detectIE())
                                window.navigator.msSaveBlob(file, 'VerificaFirma_' + fileName + '.pdf');
                            else
                                a.download = 'VerificaFirma_' + fileName + '.pdf';

                            a.click();
                            document.body.removeChild(a);
                        })
                        .catch(function (message) {
                            logError('Impossibile scaricare il file');
                        });
                }
            });

        }

        // DELETE ATTACH2
        function deleteAttach(item) {
            if (item == undefined) return;

            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: entit\xE0 bloccata. ');
                    if (data == "401") return logError('Attenzione: azione non autorizzata. ');
                    if (data == "404") return logError('Attenzione: azione non autorizzata. ');

                    //Popolo l'oggetto att da cancellare
                    var index = vm.list.attach_ades.indexOf(item)
                    var att = {};
                    att.TAttachId = vm.list.attach_ades[index].TAttachId;
                    att.TAttach = vm.list.attach_ades[index].TAttach;

                    return datacontext.tAttachVisibility_getAll(0, 0, vm.tSourceCode_ADES).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        var myTAV = _.find(tAttVis, { 'TAttachId': att.TAttachId });

                        if (typeof (myTAV) == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        att.bRead = myTAV.bRead;
                        att.bInsert = myTAV.bInsert;
                        att.bUpdate = myTAV.bUpdate;
                        att.bDelete = myTAV.bDelete;
                        att.iTags = myTAV.iTags;

                        //Individuo la tipologia corrispondente
                        var item_TA = _.find(vm.tAttach_Needed, { 'Id': att.TAttachId });
                        //Raggruppo la lista per tipologia
                        var items = _.groupBy(vm.list.attach_ades, { 'TAttachId': att.TAttachId });

                        //Se ho un allegato per la tipologia
                        if (items.true.length == 1 || item_TA.MaxValue == items.true.length) {
                            vm.list.attach_ades[index] = att; //Ripulisco il record
                        }
                        else if (item_TA.MaxValue > items.true.length) {
                            //Rimuovo l'oggetto
                            vm.list.attach_ades.splice(index, 1);
                        }
                    });
                });
            });
        }


        // ADD ATTACH2
        function addAttach(tAttachId) {
            var recTSource = {};
            var recSource = {};

            if (vm.record != undefined && vm.record.Id != undefined && vm.record.Id != 0) {
                recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
                recSource = { Id: vm.record.Id, Name: vm.ades_ref };

                var modalInstance = modal.open({
                    templateUrl: '/app/attach/modal/attachAdd2.html?version=56',
                    controller: 'attachAdd2',
                    backdrop: 'static',
                    resolve: {
                        tSource: function () {
                            return [recTSource];
                        },
                        tSourceCode: function () {
                            return vm.tSource.Code;
                        },
                        tSourceId: function () {
                            return vm.tSource.Id;
                        },
                        source: function () {
                            return [recSource];
                        },
                        sourceId: function () {
                            return recSource.Id;
                        },
                        tAttach: function () {
                            return vm.tAttach_Needed;
                        },
                        tAttachId: function () {
                            return tAttachId;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                    if (returnItem == "400") return logError('Errore registrazione dati');

                    logSuccess('Dato salvato con successo! ');
                    populateAttach();
                }, function () {
                    //log('Modal dismissed at: ' + new Date());
                });

                return true;
            } else return;
        };

        //************************END*****************************



        //*************************************
        // Curriculum Vitae

        //function resetTitoloFields(index) {
        //    switch (index) {
        //        case 1:
        //            if (!vm.currVitae.bTitolo01) {
        //                vm.currVitae.Titolo01_Id = 0;
        //                vm.currVitae.Titolo01_Desc = '';
        //                vm.currVitae.Titolo01_Ist = '';
        //                vm.currVitae.Titolo01_Mese = 0;
        //                vm.currVitae.Titolo01_Anno = 0;
        //                vm.currVitae.Titolo01_Voto = 0;
        //                vm.currVitae.Titolo01_Max = 0;
        //            }
        //            break;
        //        case 2:
        //            if (!vm.currVitae.bTitolo02) {
        //                vm.currVitae.Titolo02_Id = 0;
        //                vm.currVitae.Titolo02_Desc = '';
        //                vm.currVitae.Titolo02_Ist = '';
        //                vm.currVitae.Titolo02_Mese = 0;
        //                vm.currVitae.Titolo02_Anno = 0;
        //                vm.currVitae.Titolo02_Voto = 0;
        //                vm.currVitae.Titolo02_Max = 0;
        //            }
        //            break;
        //        case 3:
        //            if (!vm.currVitae.bTitolo03) {
        //                vm.currVitae.Titolo03_Id = 0;
        //                vm.currVitae.Titolo03_Desc = '';
        //                vm.currVitae.Titolo03_Ist = '';
        //                vm.currVitae.Titolo03_Mese = 0;
        //                vm.currVitae.Titolo03_Anno = 0;
        //                vm.currVitae.Titolo03_Voto = 0;
        //                vm.currVitae.Titolo03_Max = 0;
        //                vm.currVitae.Titolo03_Lode = false;
        //            }
        //            break;
        //    }
        //}

        //function setCompleted_CV() {
        //    if (!vm.currVitae.Sent && !vm.currVitae.Completed)
        //        bDialog.confirmationDialog('Attenzione', 'Completando non sar\xE0 possibile apportare modifiche al proprio CV.', 'OK').then(
        //            function () { //YES
        //                vm.currVitae.Completed = true;
        //                return saveAll().then(function (data) {
        //                    if (data)
        //                        return printPDF_CV();
        //                    return true;
        //                });
        //            },
        //            function () { //NO
        //                //vm.record.Completed = false;
        //            }
        //        );
        //}

        //function unlockCVItem() {
        //    if (vm.currVitae.Completed) {
        //        var item = vm.currVitae;
        //        var msg = item.CNDDomandaAdesioneId;
        //        bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare il cv dell\'adesione (' + msg + ')', 'OK').then(
        //            function () { //YES
        //                return datacontext.cndCV_unlock(item).then(function (data) {
        //                    if (data != "204") return logError('Errore: operazione non consentita');
        //                    vm.currVitae.Completed = false;
        //                });
        //            },
        //            function () { //NO
        //                //
        //            }
        //        );
        //    }
        //}

        //function setSent_CV() {
        //    if (!vm.currVitae.Sent && vm.currVitae.Completed)
        //        bDialog.confirmationDialog('Attenzione', 'Effettuando la trasmissione non sar\xE0 possibile caricare altri documenti.', 'OK').then(
        //            function () { //YES
        //                vm.currVitae.Sent = true;
        //                return saveAll().then(function (data) {
        //                    return true;
        //                });
        //            },
        //            function () { //NO
        //                //vm.currVitae.Sent = false;
        //            }
        //        );
        //}


        //function saveAll() {
        //    if (vm.list.cv_specs.length > 0 && vm.list.cv_servizi.length > 0)
        //    {
        //        //console.log('SaveAll: entrambi > 0');
        //        return saveAllSpec().then(function (data) {
        //            return saveAllServizio().then(function (data) {
        //               return saveCV();
        //            });
        //        });
        //    }
        //    else if (vm.list.cv_specs.length > 0 && vm.list.cv_servizi.length == 0) {
        //        //console.log('SaveAll: vm.list.cv_specs.length > 0');
        //        return saveAllSpec().then(function (data) {
        //            return saveCV();
        //        });
        //    }
        //    else if (vm.list.cv_specs.length == 0 && vm.list.cv_servizi.length > 0) {
        //        //console.log('SaveAll: vm.list.cv_servizi.length > 0');
        //        return saveAllServizio().then(function (data) {
        //            return saveCV();
        //        });
        //    }
        //    else { 
        //        //console.log('SaveAll: entrambi nulli');
        //        return saveCV();
        //    }
        //}


        ////***************************
        //// Get URL Allegato CURRICULUM VITAE

        //function getPDFCV() {
        //    return datacontext.cndCV_findCV($routeParams.domandaAdesioneUID, $routeParams.projectUID)
        //        .then(function (data) {                    
        //            if (data && data.url) {
        //                return vm.linkPDFCV = data.url;
        //            }
        //        });
        //}

        ////*******************************
        //// Print PDF CURRICULUM VITAE

        //function printPDF_CV() {
        //    return datacontext.cndCV_printPDF($routeParams.projectUID, $routeParams.domandaAdesioneUID)
        //        .then(function (data) {
        //            if (data && data.url) {
                        
        //                return vm.linkPDFCV = data.url;
        //            }
        //        });
        //}


        ////****************************
        //// CND CV

        //function getCV(Uid) {
        //    return datacontext.cndCV_getByDomandaUID(Uid).then(function (data) {
        //        if (data) {
        //            vm.currVitae = data;

        //            if (vm.currVitae.Completed) {
        //                vm.showPanel_cv2 = false;
        //                vm.showPanel_cv3 = false;
        //                vm.showPanel_cv4 = false;
        //                vm.showPanel_cv5 = false;
        //            }

        //            //Parametro di appoggio per send_Email
        //            vm.currVitae.ProgettoUId = $routeParams.projectUID;

        //            //azzero liste
        //            vm.list.cv_specs = [];
        //            vm.list.cv_servizi = [];

                    
        //            getAllSpec(vm.currVitae.CNDDomandaAdesioneId);
        //            getAllServizio(vm.currVitae.CNDDomandaAdesioneId);
        //        }
                
        //        return true;
        //    });
        //}

        //function saveCV() {
        //    if (vm.currVitae == null || vm.currVitae.Id == null)
        //    {
        //        vm.currVitae.CNDDomandaAdesioneId = vm.record.Id;
        //        return datacontext.cndCV_add(vm.currVitae).then(function (data) {
        //            if (data) {
        //                if (vm.showDivs.ableToPDF2)
        //                    printPDF_CV();
        //            }

        //            logSuccess('Dati salvati. ');
        //            return true;
        //        });
        //    }
        //    else
        //    {
        //        return datacontext.cndCV_update(vm.currVitae).then(function (data) {
        //            if (data)
        //                if (vm.showDivs.ableToPDF2)
        //                    printPDF_CV();

        //            logSuccess('Dati salvati. ');

        //            return true;
        //        });
        //    }
        //}

        ////****************************
        //// CNDCV_Spec

        //function getAllSpec(domandaAdesioneId) {
        //    return datacontext.cndCVSpec_getAll(0, 0, domandaAdesioneId, -1, -1, -1, -1, 'IDDomanda').then(function (data) {
        //        return vm.list.cv_specs = data;
        //    });
        //}

        //function addSpec() {
        //    if (vm.cv_spec.Titolo == null || vm.cv_spec.Ente == null || vm.cv_spec.Mese == null || vm.cv_spec.Anno == null)
        //        return log('Riempi tutti i campi della scheda');

        //    vm.cv_spec.CNDDomandaAdesioneId = vm.record.Id;

        //    vm.list.cv_specs.push(vm.cv_spec);

        //    vm.cv_spec = {};
        //}

        //function deleteSpec(item) {
        //    if (item.Id > 0) {
        //        datacontext.cndCVSpec_delete(item.Id).then(function (data) { });
        //    }

        //    var index = vm.list.cv_specs.indexOf(item)
        //    vm.list.cv_specs.splice(index, 1);
        //}

        //function saveAllSpec() {
        //    var items = vm.list.cv_specs;

        //    return datacontext.cndCVSpec_saveAll(items).then(function (data) {
        //        //if (data == "404") return logError('Errore sul salvataggio. ');

        //        return true;//logSuccess('Record Salvati. ');
        //    });
        //}

        ////****************************
        //// CNDCV_Servizio

        //function getAllServizio(domandaAdesioneId) {
        //    return datacontext.cndCVServizio_getAll(0, 0, domandaAdesioneId, -1, -1, -1, -1, 'IDDomanda').then(function (data) {
        //        return vm.list.cv_servizi = data;
        //    });
        //}

        //function addServizio() {
        //    if (vm.cv_servizio.Ente == null || vm.cv_servizio.Descrizione == null || vm.cv_servizio.MeseDa == null || vm.cv_servizio.AnnoDa == null || vm.cv_servizio.MeseA == null || vm.cv_servizio.MeseA == null )
        //        return log('Riempi tutti i campi della scheda');

        //    vm.cv_servizio.CNDDomandaAdesioneId = vm.record.Id;

        //    vm.list.cv_servizi.push(vm.cv_servizio);

        //    vm.cv_servizio = {};
        //}

        //function deleteServizio(item) {
        //    if (item.Id > 0) {
        //        datacontext.cndCVServizio_delete(item.Id).then(function (data) { });
        //    }

        //    var index = vm.list.cv_servizi.indexOf(item)
        //    vm.list.cv_servizi.splice(index, 1);
        //}

        //function saveAllServizio() {
        //    var items = vm.list.cv_servizi;

        //    return datacontext.cndCVServizio_saveAll(items).then(function (data) {
        //        //if (data == "404") return logError('Errore sul salvataggio. ');

        //        return true;//logSuccess('Record Salvati. ');
        //    });
        //}

        //************************END*****************************

		//Elenchi Parametri
		function getTSource(code) {
			if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
			});
		}

		function getTAttach(code) {
			if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
			});
        }

        

        function getTitoliStudio() {
            if (vm.cmblist.titoliStudio.length > 0) return;

            return datacontext.arrTitoliStudio().then(function (data) {
                return vm.cmblist.titoliStudio = data;
            });
        }

        function getStatiCivili() {
            if (vm.cmblist.staticivili.length > 0) return;

            return datacontext.arrStatiCivili().then(function (data) {
                return vm.cmblist.staticivili = data;
            });
        }

        function getStatoOccup() {
            if (vm.cmblist.statiOccup.length > 0) return;

            return datacontext.arrStatiOccup().then(function (data) {
                return vm.cmblist.statiOccup = data;
            });
        }

        function getProfili(progettoId) {
            if (vm.cmblist.profili.length > 0) return;
            
            return datacontext.cndTProfilo_getAll(progettoId).then(function (data) {
                return vm.cmblist.profili = data;
            });
        }

        

        //******************************
        // Birth
        function getPaesi_Nasc() {
            if (vm.cmblist.nasc_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.nasc_paesi = data;
            });
        }

        function getProvince_Nasc() {
            if (vm.cmblist.nasc_province.length > 0) return;

			datacontext.arrProvince().then(function (data) {
                vm.cmblist.nasc_province = data;
			});
		}

        function resetComuni_Nasc(idprov) {
            vm.record.NascComuneId = 0;
            getComuni_Nasc(idprov);
        }

        function getComuni_Nasc(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.nasc_comuni = [];
            }

            if (vm.record.NascProvinciaId != idprov)
                vm.cmblist.nasc_comuni = [];

			return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.nasc_comuni = data;
			});
        }

        function reset_PaeseNasc() {
            if (vm.record.NascPaeseId != 0) {
                vm.record.NascProvinciaId = 0;
                resetComuni_Nasc(0);
            }
        }

        //******************************
        // Residenza
        function getPaesi_Res() {
            if (vm.cmblist.res_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.res_paesi = data;
            });
        }

        function getProvince_Res() {
            if (vm.cmblist.res_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.res_province = data;
            });
        }

        function resetComuni_Res(idprov) {
            vm.record.ResComuneId = '';
            getComuni_Res(idprov);
        }

        function getComuni_Res(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.res_comuni = [];
            }

            if (vm.record.ResProvinciaId != idprov)
                vm.cmblist.res_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.res_comuni = data;
            });
        }

        function reset_PaeseRes() {
            if (vm.record.ResPaeseId != 0) {
                vm.record.ResProvinciaId = 0;
                resetComuni_Res(0);
            }
        }

        function reset_DomUgualeRes() {
            if (vm.record.DomUgualeRes == 0) {
                vm.record.DomPaeseId = '';
                vm.record.DomProvinciaId = '';
                vm.record.DomComuneId = '';
                vm.record.DomIndirizzo = '';
                vm.record.DomCap = '';
            }
        }


        //******************************
        // Domicilio
        function getPaesi_Dom() {
            if (vm.cmblist.dom_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.dom_paesi = data;
            });
        }

        function getProvince_Dom() {
            if (vm.cmblist.dom_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.dom_province = data;
            });
        }

        function resetComuni_Dom(idprov) {
            vm.record.DomComuneId = 0;
            getComuni_Dom(idprov);
        }

        function getComuni_Dom(idprov) {
            if (!idprov || idprov == 0) {
                
                return vm.cmblist.dom_comuni = [];
            }

            if (vm.record.DomProvinciaId != idprov)
                vm.cmblist.dom_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.dom_comuni = data;
            });
        }

        function reset_PaeseDom() {
            if (vm.record.DomPaeseId != 0) {
                vm.record.DomProvinciaId = 0;
                resetComuni_Dom(0);
            }
        }

        //********************************
        //Dich1

        function getCittadinanze_Dich1_02() {
            if (vm.cmblist.dich1_02_cittadinanze.length > 0) return;

            datacontext.arrCittadinanze().then(function (data) {
                vm.cmblist.dich1_02_cittadinanze = data;
            });
        }

        function getProvince_Dich1_03() {
            if (vm.cmblist.dich1_03_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.dich1_03_province = data;
            });
        }

        function resetComuni_Dich1_03(idprov) {
            vm.record.Dich1_03_ComuneId = 0;
            getComuni_Dich1_03(idprov);
        }

        function getComuni_Dich1_03(idprov) {
            if (!idprov || idprov == 0) {
                vm.record.Dich1_03_ComuneId = 0;
                return vm.cmblist.dich1_03_comuni = [];
            }

            if (vm.record.Dich1_03_ProvinciaId != idprov)
                vm.cmblist.dich1_03_comuni = [];
                

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.dich1_03_comuni = data;
            });
        }


        function reset_Dich1_02() {
            if (!vm.record.Dich1_02) {
                vm.record.Dich1_02_CittadinanzaId = '';
            }
        }

        function reset_Dich1_05_condanne() {
            if (!vm.record.Dich1_05_Condanne) {
                vm.record.Dich1_05_Aree = '';
            }
        }

        function reset_Dich1_08() {
            if (!vm.record.Dich1_08) {
                vm.record.Dich1_08_Titolo = '';
            }
        }

        function reset_Dich2_09() {
            if (!vm.record.reset_Dich2_09) {
                vm.record.Dich2_09_Permesso = false;
            }
        }

        

		//Metodi interfaccia Filtri
		function setfAttach() {
			if (vm.checkfAttach == false) {
				vm.fAttach.TAttachId = '';
			}
		}



		//****************************************************
		// OPEN MODAL DIALOG
		//****************************************************
		function addModal() {
            /*
            var modalInstance = modal.open({
				templateUrl: '/app/azienda/modal/aziendaAdd.html?version=56',
				controller: 'aziendaAdd',
                backdrop: 'static',
				resolve: {
					istituti: function () {
						return vm.istituti;
					},
					istitutoId: function () {
						return null;
					},
					corsi: function () {
						return vm.corsi;
					},
					corsoId: function () {
						return null;
					},
					misure: function () {
						return vm.misure;
					},
					misuraId: function () {
						return null;
					},
					ruoloSoggettoId: function () {
						return vm.fRuoloSoggettoId_def;
					},
					tFormaGiuridica: function () {
						return vm.lstFormaGiuridica;
					},
					bAPL: function () {
					    return vm.fBApl_def;
					},
					bCPI: function () {
					    return vm.fBCpi_def;
					}
				}
			});

			modalInstance.result.then(function (returnItem) {
			    if (!returnItem) return logError('errore di creazione! ');
			    if (returnItem == "409") return logError('Azienda Esistente! ');
			    if (returnItem == "406") return logError('Azienda non inserita, perche\' Partita IVA e/o Codice Fiscale non valido');

				logSuccess('Dato salvato con successo! ');
				addRecord(returnItem.Id);
			}, function () {
				//log('Modal dismissed at: ' + new Date());
			});
            */
		};

        
		

		

	    //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS DomandaAdesione FOR CF -#-#-#-#-#-#
		vm.existsCF = false;
		vm.searchCF = function (value) {
		    //console.log('searchCF()');
		    if (value == undefined) return;
		    if (value.length != 16) return; //numero minimo di caratteri
            vm.existsCF = false;
            return datacontext.cndDomandaAdesione_exists(vm.record.Id, value, vm.cndProgetto.Id).then(function (data) {
		        vm.existsCF = data;
		    });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = function (value) {
            var requiredLen = 16;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.validCF = false;
            return datacontext.validazione_cf(value, false).then(function (data) {
                return vm.validCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.getValidFieldsCF = function () {  
            vm.validFieldsCF = false;
            if (vm.record.CodiceFiscale == undefined) return;
            if (vm.record.CodiceFiscale.length != 16 && vm.record.CodiceFiscale.length != 11) return; //numero minimo di caratteri
            if (vm.record.Nome == undefined) return;
            if (vm.record.Cognome == undefined) return;
            if (vm.record.Sesso == undefined) return;
            if (vm.record.NascPaeseId == 0 && (vm.record.NascComuneId == undefined || vm.record.NascComuneId == 0)) return;
            if (vm.record.NascData == undefined || vm.record.NascData == '') return;
            var strDtNasc = common.dateToString(vm.record.NascData); //la data deve avere formato dd/MM/yyyy
            return datacontext.validazione_fieldsCF(vm.record.CodiceFiscale, vm.record.Nome, vm.record.Cognome, vm.record.Sesso, strDtNasc, vm.record.NascPaeseId, vm.record.NascComuneId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN = true;
        vm.getValidIBAN = function (value) {
            var requiredLen = 27;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.validIBAN = false;
            return datacontext.validazione_iban(value).then(function (data) {
                return vm.validIBAN = data;
            });
        }

	    
            
	}
})();
